import React from 'react'
import BaseComponent from './BaseComponent'

export default class UserPage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { options: [], id: 1, preloader: true, repeat: "", passerr: false }
    this._bind('handleInputChange', 'save', 'handlePassChange')
  }

  UNSAFE_componentWillMount() {
    this.props.data.fields.map((item, i) => {
      this.setState({
        [item.name]: ""
      })

      return null
    })
  }

  componentDidMount() {
    fetch(this.props.API+"/auth/describe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer " + sessionStorage.getItem('token')
      }
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      let single = result.data.editor
      this.props.data.fields.map((item, i) => {
        if (single[item.name]) {
          this.setState({
            [item.name]: single[item.name]
          })
        }

        return null
      })
      this.setState({ id: single.id, preloader: false })
    }, (error) => {
      console.log(error)
    })
  }

  handleInputChange(event, editor) {
    const target = event.target
    let value
    if(target.type === 'checkbox') {
      value = target.checked ? "1" : "0"
    } else {
      value = target.value
    }
    let name = target.name

    this.setState({
      [name]: value
    })
  }

  handlePassChange(event) {
    const target = event.target
    let value = target.value
    let name = target.name

    this.setState({
      [name]: value
    })
  }

  add(e) {
    e.preventDefault()

    if (this.state.pass !== this.state.repeat) {
      this.setState({ passerr: true })
    } else {
      this.setState({ passerr: false })
    }

    if(true && (this.state.pass === this.state.repeat)) {
      this.save()
    }
  }

  save() {
    this.setState({ preloader: true })
    let params = {
      user: this.state
    }
    fetch(this.props.API+"/user/update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer " + sessionStorage.getItem('token')
      },
      body: JSON.stringify(params)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.meta?.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : result.error}}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie zapisano zmiany."}}), true);
        this.setState({ pass: "", repeat: "", changePass: "0" })
      }
      this.setState({ preloader: false })
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Something went wrong."}}), true);
    })
  }

  render () {

    let fields = this.props.data.fields.map((item, i) => {
      if (item.type === "text") {
        return (
          <div key={ i }>
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            <input disabled type="text" name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } required={ item.required ? true : false }/>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
          </div>
        )
      } else if (item.type === "checkbox") {
        return (
          <div key={ i } className="checkbox">
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <input type="checkbox" id={ i } name={ item.name } value={ this.state[item.name] } onChange={ this.handleInputChange } checked={ this.state[item.name] === "1" ? true : false }/>
            <label htmlFor={ i }></label>
          </div>
        )
      } else if (item.type === "passwd") {
        return (
          <div key={ i } className="title">
            <h4>{ item.placeholder }{ item.required ? <span>*</span> : null }</h4>
            { item.desc ? <p className="input-desc">{ item.desc }</p> : null }
            <input type="password" name={ item.name } value={ this.state[item.name] } onChange={ this.handlePassChange } data-parsley-pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$" required={ item.required ? true : false }/>
            <p className="input-desc">Powtórz hasło</p>
            <input type="password" name="repeat" value={ this.state.repeat } onChange={ this.handlePassChange } data-parsley-pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$" required={ item.required ? true : false }/>
            { this.state.passerr ? <p className="error">Hasła są różne!</p> : null }
          </div>
        )
      } else {
        return null
      }
    })

    return (
      <section className="new">
        <div className="container">
          <h1>Ustawienia użytkownika</h1>
          <form className="fields" data-parsley-validate>
            {/* <div className="add-top" onClick={ this.add }>Zapisz zmiany</div> */}
            { fields }
            {/* <div className="add-bottom" onClick={ this.add }>Zapisz zmiany</div> */}
            { this.state.preloader ? <div className="preloader"><span></span></div> : null }
          </form>
        </div>
      </section>
    )
  }
}
